import React from "react"

import { Row, Image, Col } from "react-bootstrap"
import renderElement from "../../../utils/renderElement"

import "./company.scss"

const Company = ({ article, isBlog }) => {
  return (
    <section className="company-section">
      <div className={isBlog ? " " : "container"}>
        {article?.title && (
          <h4
            className="mb-0"
            dangerouslySetInnerHTML={renderElement(article?.title)}
          ></h4>
        )}
        <div className="company-section__logo">
          <Row className=" align-items-center">
            {article?.logos?.map(logo => (
              <Col key={logo?.image?.ID} className="text-center" lg="2" md="4">
                {logo?.outllink ? (
                  <a href={logo.outllink} target="_blank" rel="noreferrer">
                    <Image
                      className="marginTop30 img-fluid"
                      src={logo?.image?.url}
                      alt={logo?.image?.alt}
                    />
                  </a>
                ) : (
                  <Image
                    className="marginTop30 img-fluid"
                    src={logo?.image?.url}
                    alt={logo?.image?.alt}
                  />
                )}
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </section>
  )
}

export default Company
